import type { ForecastingField } from './types';

export const FORECASTING_FIELDS: Array<ForecastingField> = [];
